import './PracticeIntroVideo.scss'

import { useHistory } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import cn from 'classnames'

import { navigateTo } from '../../common/navigation'
import { ROUTE_ACTIVITIES_ALL } from '../../common/helpers/Paths'

/**
 * Practice Intro Video component. Used for displaying an intro video thumb with a link to the fullscreen video.
 * @param {Object} data Video data
 * @param {String} baseUrl The base URL for the practice. Used as the return path
 */
export default function PracticeIntroVideo({ data, baseUrl }) {
  const history = useHistory()
  const videoUrl = data?.why?.videoURL

  return (
    data && (
      <>
        <h4 className='practice-intro-video-title'>{data.why.title}</h4>
        <Row className='practice-intro-video'>
          <Col xs={4} md={7} lg={5}>
            <div
              onClick={() => {
                // Return early if we don't have a video URL
                if (!videoUrl) return

                navigateTo(
                  `${ROUTE_ACTIVITIES_ALL}/why/${data.key}?returnPath=${baseUrl}`,
                  history
                )
              }}
              className={cn('practice-intro-video-img', {
                'cursor-pointer': videoUrl
              })}
              style={{ backgroundImage: `url(${data.image})` }}
            >
              {videoUrl && <i className='bi bi-play-fill' />}
            </div>
          </Col>
          <Col
            xs={8}
            md={5}
            lg={7}
            className='practice-intro-video-details-col'
          >
            <div className='practice-intro-video-details'>
              <p className='practice-intro-video-summary'>
                {data.why.subtitle}
              </p>
            </div>
          </Col>
        </Row>
      </>
    )
  )
}
